import { RELAY_API_CONTENTFUL } from '@/utils/constant';

import { init as initRelay } from '../../../../init-relay-streaming';
import { ConfluenceTemplateCategoryRelayPage } from '../../../../pages/software/confluence/templates/categories/confluence-template-category-contentful-relay-page';
import {
	ConfluenceTemplatesUnifiedRelayPageQuery,
	getConfluenceTemplatesUnifiedRelayPageQueryVars,
} from '../../../../templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-templates-unified-contentful-relay-page.template';

initRelay(
	ConfluenceTemplateCategoryRelayPage,
	ConfluenceTemplatesUnifiedRelayPageQuery,
	getConfluenceTemplatesUnifiedRelayPageQueryVars(window.location),
	RELAY_API_CONTENTFUL,
);
